import { Injectable } from '@angular/core';
import { AlertController, App } from 'ionic-angular';
import { Http } from '@angular/http';


@Injectable()
export class InactiveServiceProvider {
  private logoutTimeout: any;
  private alertTimeout: any;
  private readonly inactivityPeriod = 5 * 60 * 1000; // 5 minutes
  private readonly alertPeriod = 1000; // 1 minute before logout alert

  constructor(
    private http: Http,
    private alertCtrl: AlertController,
    private app: App
  ) { }

  start_Timer_Count() {
    this.initializeInactivityTimer();
    this.setupEventListeners();
  }

  private initializeInactivityTimer() {
    this.resetTimer();
  }

  private resetTimer() {
    clearTimeout(this.logoutTimeout);
    clearTimeout(this.alertTimeout);

    this.alertTimeout = setTimeout(() => this.showAlert(), this.inactivityPeriod - this.alertPeriod);
    this.logoutTimeout = setTimeout(() => this.logout(), this.inactivityPeriod);
  }

  private setupEventListeners() {
    const events = ['mousemove', 'keydown', 'click', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, () => this.resetTimer());
    });
  }

  private logout() {
    let dummychatbutton = document.getElementById('dummychatbutton');
    let frame = document.getElementById("consectus_iframechat").style.display;
    if (dummychatbutton.style.display !== "none" || dummychatbutton.style.display != "none" || !frame) {
      console.log("User has been logged out due to inactivity.");
      this.app.getRootNav().setRoot('WebLoginPage');
    }
  }

  private async showAlert() {
    let dummychatbutton = document.getElementById('dummychatbutton');
    if (dummychatbutton.style.display !== "none" || dummychatbutton.style.display != "none") {
      const alert = await this.alertCtrl.create({
        title: 'Timeout Warning',
        message: 'Due to inactivity, you have been logged out of your account for security reasons',
        cssClass: 'timeout-alertDanger',
        buttons: [
          {
            text: 'Logout',
            role: 'confirm',
            handler: () => {
              this.app.getRootNav().setRoot('WebLoginPage');
              location.href = "#/web-login";
              location.reload();
            }
          }
        ],
        enableBackdropDismiss: false
      });
      await alert.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/inactive-service/inactive-service.ts